export default __webpack_public_path__ + "static/reading-5d476d51928e8cb426f081f47da5742c.webp";